import * as service from './header.service'
export default {

  data() {
    return {
      stateName: '',
      userName: '',
      currentUser: '',
      Heading: '',
      headingFullText: '',
      burgerrotate: true,
      isMob: false,
      imgPath: '',
      isdisablebutton: true,
      Ispasswordok: false,
      ResetForm: {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: '',

      },
      dLocation: '',
      dPoolName: ''
    }
  },

  mounted() {

    let context = this

    //FG - FOOF - Apr 5 2019
    // this.widthCalculator()
    this.locPoolSe()

    $(window).resize(function () {
      //context.widthCalculator()
    })
    this.stateName = this.$route.name 
    
    this.Heading = this.$route.matched ? this.$route.matched['0'].props.default.default.name : ''
    if(this.stateName == "dashboard") this.Heading = "Dashboard"; //FG - FOOF - Jan 23 2019
    
    //FG - FOOF - Jan 23 2019
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.dLocation = data.LocationName
      //FG - FOOF - After Cert - First Release (4)
      //I reinstated the facility and venue name in the heading and added the code below
      //so there would not be a venue name displayed when the chosen facility does not
      //have a venue.
      if(data.PoolId != null && data.PoolId.LocationId != data.LocationId) {
        context.dPoolName = "No Venue"
      }
    })
    this.$router.app.$on('emittedlocation', (data) => {
      //alert("good by")
      context.dLocation = data
      context.buildHeaderTextFull(context.stateName, context.dLocation, context.$data.dPoolName); //FG - FOOF - 20200806-FG-0001
    })

    //FG - FOOF - Apr 5 2019
    this.$router.app.$on('emittedpool_obj', (data) => {
      context.dPoolName = data.PoolName ? data.PoolName : ''
      context.buildHeaderTextFull(context.stateName, context.$data.dLocation, context.dPoolName); //FG - FOOF - 20200806-FG-0001
    })
    
    this.userName = window.userName ? window.userName : ''
    this.currentUser = authDetails.userName
    this.$router.app.$on('reloadAuth', (data) => {
      this.currentUser = authDetails.userName
      authDetails.ImageName ? context.imgPath = baseUrl + 'Documents/ProfilePics/' + authDetails.ImageName : context.imgPath = ''
      context.userName = window.userName ? window.userName : ''

    })

    if (this.stateName != 'login' && this.stateName != 'resetpassword' && this.stateName != 'signup' && this.stateName != 'signupconfirm') {
      authDetails.ImageName ? this.imgPath = baseUrl + 'Documents/ProfilePics/' + authDetails.ImageName : this.imgPath = ''
    }

  },
  watch: {
    '$route' (to, from) {
      this.Heading = to.matched['0'].props.default.default.name
      this.stateName = to.name
      if(this.stateName == 'dashboard') this.Heading = "Dashboard"
      //this.Heading = "sheeet" + this.stateName

      this.userName = window.userName ? window.userName : ''

      if (authDetails) {
        this.currentUser = authDetails.userName
        authDetails.ImageName ? this.imgPath = baseUrl + 'Documents/ProfilePics/' + authDetails.ImageName : this.imgPath = ''
      }

    //FG - FOOF - 20200806-FG-0001
    this.buildHeaderTextFull(this.$data.stateName, this.$data.dLocation, this.$data.dPoolName);

    },
    ResetForm: {
      handler: function (newValue) {
        if (newValue.NewPassword.length >= 8 && newValue.NewPassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/) && newValue.NewPassword.match(/^(?=.*[A-Z])/) && newValue.NewPassword == newValue.ConfirmPassword) {

          this.isdisablebutton = false;
        } else {
          this.isdisablebutton = true;
        }
        if (newValue.NewPassword.length >= 8 && newValue.NewPassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/) && newValue.NewPassword.match(/^(?=.*[A-Z])/)) {

          this.Ispasswordok = false;
        } else {
          this.Ispasswordok = true;
        }
      },
      deep: true
    },
    burgerrotate() {

      this.$router.app.$emit('BurgerRotated', this.burgerrotate)

    }
  },


  methods: {
    //FG - FOOF - 20200806-FG-0001
    //  I modified the code such that the page heading will only display Location name and Pool name along with the page title 
    //  (if they are available) when the dashboard is being shown.  Otherwise it will display only the page title.
    buildHeaderTextFull(stateName, locName, poolName) {
      if(stateName == "dashboard") {
        var tempHead = this.$data.Heading;
        /*
        FG - FOOF - Change for certification
        >>>>>>>>>>>>FG - FOOF - NEED TO FIX AFTER CERTIFICATION <<<<<<<<<
        NOTE: THIS CODE IS COMMENTED OUT UNTIL AFTER CERTIFICATION
              BECAUSE IT DOES NOT PROPERLY SET THE LOC/POOL IN THE HEADER
        if(this.$data.dLocation != null && this.$data.dLocation != "undefined" && this.$data.dLocation.length != 0) {
          tempHead = tempHead + " - " + this.$data.dLocation;
          if(this.$data.dPoolName != null && this.$data.dPoolName != "undefinded" && this.$data.dPoolName.length != 0)
            tempHead = tempHead + " - " + this.$data.dPoolName;
        } 
        */
        this.$data.headingFullText = tempHead;
      }
      else
        this.$data.headingFullText = this.$data.Heading;
    },

    viewAlerts() {
      $('#emailAlert').modal('show')
    },

    notificationClose() {
      this.$router.app.$emit('notification_close')
    },
    toggleCurrentPassword() {

      if (!this.passClicked) {
        $('#passwordCurrent').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#passwordCurrent').children().attr('type', 'password')
        this.passClicked = false
      }
    },
    togglePassword() {

      if (!this.passClicked) {
        $('#password').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#password').children().attr('type', 'password')
        this.passClicked = false
      }
    },
    togglePasswordConfirm() {

      if (!this.passClickedConfirm) {
        $('#passwordconfirm').children().attr('type', 'text')
        this.passClickedConfirm = true
      } else {
        $('#passwordconfirm').children().attr('type', 'password')
        this.passClickedConfirm = false
      }

    },
    submitchangePassword(model) {
      let context = this
      this.isdisablebutton = true
      service.ChangePassword(model).then(function (response) {
        context.isdisablebutton = false
        loader.stopLoader()

        context.$notify({
          title: 'Success',
          message: 'Password changed successfully',
          type: 'success'
        })
        $('#ChangePasswordModel').modal('hide')
      }).catch((error) => {
        context.isdisablebutton = false
        var message = error.responseText
        var parsed = JSON.parse(message)

        context.$notify.error({
          title: 'Error',
          message: parsed.Message
        })
        context.buttonclicked = true

        loader.stopLoader()
        $('.alert').show()
      })

    },

    changepassword() {

      $('#ChangePasswordModel').modal('show')
      this.ResetForm = {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      }
    },

    myprofile() {

      this.$router.push('/UpdatePersonnel/' + authDetails.PersonnelId)
    },

    locPoolSe() {
      $('ul.dropdown-menu.mega-dropdown-menu').on('click', function (event) {

        event.stopPropagation()
      })
    },

    widthCalculator() {

      let winwidth = $(window).width()

      if (winwidth < 992) {
        this.isMob = true
        this.burgerrotate = false
      } else {
        this.isMob = false
        this.burgerrotate = true
      }

    },

    logout: function () {

      this.$confirm('Are you sure you want to logout ?', 'Log Out', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        this.$localStorage.remove('authentication')
        this.$localStorage.remove('initlocation')
        this.$localStorage.remove('initialPool') //FG - After Cert - First Release - for fix of pull in (Feb 19 2021)
        window.globallocid = null //<--??? WHY DO WE NEED THIS AND THE initlocation (which seems to be used as current choice of location)
        this.$router.push('/login')

      }).catch(() => {

      })

    }

  }

}



// WEBPACK FOOTER //
// ./src/components/header/header.controller.js